import React, { useState } from 'react';
import { useField } from 'formik';
import { getNumberWithCommas } from '../../../utility/formatNumbers';

const PERCENT = 'percent';
const UNIT = 'unit';

function PercentTextInput({ label, layout, description, ...props }) {
  const [field, meta, helpers] = useField(props);
  const { value, touched, error } = meta;
  const { setValue } = helpers;

  const initialSelected = value?.includes('_')
    ? value.substring(value.indexOf('_') + 1)
    : PERCENT;

  const [select, setSelect] = useState(initialSelected);

  const handleUnitSelect = (selected) => {
    setSelect(selected);
    setValue(
      `${value.replace(`_${PERCENT}`, '').replace(`_${UNIT}`, '')}_${selected}`
    );
  };

  const handleChange = (e) => {
    const num = getNumberWithCommas(e.target.value);
    setValue(`${num}_${select}`);
  };

  return (
    <div className="mt-6 sm:mt-5 space-y-6 sm:space-y-5">
      <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:border-t sm:border-primary-200 sm:pt-5">
        <label htmlFor={field.name} className="sm:mt-px sm:pt-2">
          <span className="block text-base font-medium text-neutral-700">
            {label}
          </span>
          {description && (
            <span className="block text-base text-neutral-500 font-normal">
              {description}
            </span>
          )}
          {label}
        </label>

        <div className="mt-1 relative  sm:max-w-xs col-span-2 rounded ">
          <div className="flex">
            <select
              value={select}
              onChange={(e) => handleUnitSelect(e.target.value)}
              className="block focus:ring-neutral-500 focus:border-neutral-500 w-20 mr-6 pl-3 pr-6 text-base rounded h-6 border-neutral-300 text-primary "
            >
              <option value={PERCENT}>%</option>
              <option value={UNIT}>#</option>
            </select>

            <input
              value={value && value.slice(0, value.indexOf('_'))}
              onChange={(e) => handleChange(e)}
              type="text"
              {...props}
              className={`max-w-lg block w-full shadow-sm focus:ring-neutral-500 focus:border-neutral-500  text-base rounded h-6 ${
                touched && error ? 'border-warning' : 'border-neutral-300'
              }`}
            />
          </div>

          {touched && error ? (
            <div className="error text-base font-small text-warning ">
              {error}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default PercentTextInput;
